import { Zap } from '@zapier/transfer-client';
import { getReadStepTransferMeta } from './getZdlStep';

const isRecurringTransfer = (zap: Zap) =>
  !!getReadStepTransferMeta(zap).isRecurring;

export default isRecurringTransfer;
